import { NgModule } from '@angular/core';
import { WishListRootModule } from '@spartacus/cart/wish-list/root';

@NgModule({
  declarations: [],
  imports: [WishListRootModule],
  providers: [],
})
export class WishListFeatureModule {}
